import { isCriOSUserAgent } from '~/lib/utils/user-agent'

/**
 * Chrome iOS can commit a page opened from another app (QR scan, shared link)
 * while its tab-opening animation is still running, leaving the tab's native
 * viewport offset by the collapsible-toolbar height. The web engine reports
 * healthy geometry throughout, so the state can be neither detected nor
 * corrected from JS — only a fresh navigation commit (or device rotation)
 * renders correctly; repaints, scrolling (programmatic and touch, inner and
 * root scroller), viewport-meta rewrites and tab switches were all verified
 * on-device not to heal it.
 *
 * Decides whether the current commit is at risk and should be retried once:
 * only Chrome iOS, only a cold `navigate` commit (a `reload` commit was issued
 * with settled browser UI, which also makes looping impossible), only the
 * viewport-locked event layout (other layouts render root-scrollable documents
 * where the displacement has no visible effect), and only once per tab.
 * @param {object} input
 * @param {string} [input.userAgent] navigator.userAgent
 * @param {string} [input.navigationType] PerformanceNavigationTiming.type
 * @param {string} [input.layoutName] route.meta.layout
 * @param {boolean} [input.alreadyRetried]
 * @returns {boolean}
 */
export function shouldRetryCriosCommit({ userAgent, navigationType, layoutName, alreadyRetried }) {
  return isCriOSUserAgent(userAgent) && navigationType === 'navigate' && layoutName === 'event' && !alreadyRetried
}
